"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonCta = require("@mmc/common-cta");
var _commonI18n = require("@mmc/common-i18n");
var _text = require("@mmc/text");
var _commonRichText = require("@mmc/common-rich-text");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _heroFeatureBlock = _interopRequireDefault(require("./hero-feature-block"));
var _heroBrand = _interopRequireDefault(require("./hero-brand.props/hero-brand.propTypes"));
var _heroBrand2 = _interopRequireDefault(require("./hero-brand.props/hero-brand.defaultProps"));
var _heroBrand3 = _interopRequireDefault(require("../styles/hero-brand.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageTransforms = dataUtils.appendImageTransforms;
var applyDarkTheme = function applyDarkTheme(data, theme) {
  return data.theme === 'dark' ? theme[data.theme] : '';
};
var ctaData = function ctaData(data) {
  return {
    url: handleNestedProp(data, 'data.URL'),
    label: handleNestedProp(data, 'data.label'),
    priority: handleNestedProp(data, 'data.priority'),
    ctaTheme: handleNestedProp(data, 'data.theme'),
    openNewTab: handleNestedProp(data, 'data.openNewTab'),
    icon: handleNestedProp(data, 'data.icon'),
    ctaType: handleNestedProp(data, 'data.ctaType')
  };
};
var setTextWidth = function setTextWidth(alignment, theme) {
  if (alignment !== 'center') {
    return theme['col-xs-12'] + " " + theme['col-sm-8'] + " " + theme['col-md-6'] + " " + theme['col-lg-6'] + " " + _heroBrand3["default"].heroTextContent + " " + (_heroBrand3["default"][alignment] ? _heroBrand3["default"][alignment] : '');
  }
  return theme['col-xs-12'] + " " + _heroBrand3["default"].heroTextContent + " " + (_heroBrand3["default"][alignment] ? _heroBrand3["default"][alignment] : '');
};
var imageWidth = 480;
var getPrice = function getPrice(params) {
  var data = params.data,
    theme = params.theme,
    config = params.config;
  return data.price && /*#__PURE__*/_react["default"].createElement("h2", {
    className: theme.headingFive + " " + theme.marginBottom5 + " " + _heroBrand3["default"].heading3
  }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: handleNestedProp(data, 'data.price.value'),
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode'),
      displayValue: handleNestedProp(data, 'data.price.displayValue'),
      zeroMessage: handleNestedProp(data, 'data.price.zeroMessage')
    },
    addPriceDisclaimer: handleNestedProp(data, 'data.addPriceDisclaimer'),
    priceDisclaimerId: handleNestedProp(data, 'data.priceDisclaimerId'),
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }));
};
var HeroTextBlock = function HeroTextBlock(_ref) {
  var theme = _ref.theme,
    data = _ref.data,
    config = _ref.config;
  var _useState = (0, _react.useState)(null),
    navLinks = _useState[0],
    setNavLinks = _useState[1];
  var formatNavLinks = function formatNavLinks() {
    // Need to format links after mount in order to use 'window' only on the client and not server
    if (data.navigationLinks && data.navigationLinks.length > 0) {
      var _formattedLinks = data.navigationLinks.map(function (navLink) {
        var style = typeof window !== 'undefined' && window.location.href === navLink.url ? {
          backgroundColor: '#FFFFFF',
          color: '#000000'
        } : {};
        return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
          key: navLink.url,
          theme: theme,
          data: {
            priority: 'medium',
            label: navLink.label,
            url: navLink.url,
            openNewTab: navLink.openNewTab,
            ctaProps: {
              style: style
            }
          }
        });
      });
      setNavLinks(_formattedLinks);
    }
  };
  (0, _react.useEffect)(function () {
    formatNavLinks(data);
  }, []);
  var pushBannerClickToDataLayer = function pushBannerClickToDataLayer(linkUrl) {
    var market = config.market;
    var bannerName = data.heading2;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'hero_banner_click',
        comp_page: {
          name_banner: bannerName ? bannerName.toLowerCase() : null,
          link: linkUrl ? "" + (!/^(http|https):/.test(linkUrl) ? window.location.origin : '') + linkUrl : null
        }
      });
      if (linkUrl.includes('/prueba') || linkUrl.includes('/test-drive') || linkUrl.includes('/varaa-koeajo')) {
        var modelName = '';
        if (window.location && window.location.pathname && (window.location.pathname.includes('/mallisto') || window.location.pathname.includes('/modelos') || window.location.pathname.includes('/mitsubishi-modelos'))) {
          // eslint-disable-next-line prefer-destructuring
          modelName = window.location.pathname.split('/')[2];
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'test_drive_request_click',
          comp_product: {
            position: 'page',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: modelName ? modelName.toLowerCase() : null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n      " + (data.textBlockPosition !== 'center' ? theme['col-lg-10'] : theme['col-lg-8']) + "\n      " + theme['col-md-10'] + " " + theme['col-sm-10'] + " " + applyDarkTheme(data, theme) + "\n      " + _heroBrand3["default"].heroTextWrapper + "\n      " + (_heroBrand3["default"][data.textBlockPosition] ? _heroBrand3["default"][data.textBlockPosition] : '') + "\n     "
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: setTextWidth(data.textBlockPosition, theme) + " " + (data.theme === 'dark' ? _heroBrand3["default"].isDark : '')
  }, navLinks && navLinks.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _heroBrand3["default"].navigationLinks + " " + _heroBrand3["default"][data.textBlockPosition]
  }, navLinks) : null, data.tag && /*#__PURE__*/_react["default"].createElement("div", {
    className: _heroBrand3["default"].tag
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.tags
  }, handleNestedProp(data, 'data.tag.label'))), data.vehicleLogo && /*#__PURE__*/_react["default"].createElement("div", {
    className: _heroBrand3["default"].logoWrapper
  }, data.vehicleLogo.image && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    src: appendImageTransforms(handleNestedProp(data, 'data.vehicleLogo.image'), imageWidth),
    alt: handleNestedProp(data, 'data.image.altText')
  })), data.heading1 && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: data.heading1,
    className: theme.labelMedium + " " + _heroBrand3["default"].heading1 + " " + theme.marginBottom20,
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: theme.headingOne + " " + theme.marginBottom30 + " " + _heroBrand3["default"].heading2,
    text: data.heading2,
    tag: "h1",
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }), data.heading3 && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: theme.headingFive + " " + theme.marginBottom5 + " " + _heroBrand3["default"].heading3,
    text: data.heading3,
    tag: "h2",
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }), getPrice({
    data: data,
    theme: theme,
    config: config
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      html: data.textBlock,
      className: theme.introCopy + " " + theme.marginBottom40 + " " + _heroBrand3["default"].textBlock,
      tagName: "p"
    }),
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }), data.featureBlock && /*#__PURE__*/_react["default"].createElement(_heroFeatureBlock["default"], {
    theme: theme,
    data: data,
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }), data.cta && /*#__PURE__*/_react["default"].createElement("div", {
    className: applyDarkTheme(data, theme) + " " + _heroBrand3["default"].ctaWrapper + " " + theme.marginBottom40
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: ctaData(handleNestedProp(data, 'data.cta')),
    "data-section": data.heading1,
    classes: [applyDarkTheme(data, theme) + " " + (data.cta.priority === 'lowIcon' && _heroBrand3["default"].adjustIconPosition)],
    mouseDownEvent: function mouseDownEvent() {
      return pushBannerClickToDataLayer(ctaData(handleNestedProp(data, 'data.cta')).url);
    }
  }))));
};
HeroTextBlock.defaultProps = {
  data: _heroBrand2["default"],
  config: {}
};
var _default = HeroTextBlock;
exports["default"] = _default;